import { type FC } from "react";

import { TrendIndicator } from "./components/TrendIndicator";
import { ConsensusLegend } from "./ConsensusLegend";
import * as Styled from "./MarketsLegend.styles";
import { useMarketsLegend } from "./useMarketsLegend";

export const MarketsLegend: FC = () => {
  const { items, consensus, rangeLabel, isDimmed } = useMarketsLegend();

  if (consensus) {
    return <ConsensusLegend consensus={consensus} isDimmed={isDimmed} />;
  }

  if (!items.length) {
    return null;
  }

  return (
    <Styled.Root $dimmed={isDimmed}>
      <Styled.Row>
        {items.map(
          ({
            key,
            label,
            color,
            isDashed,
            chanceLabel,
            changeLabel,
            isPositiveChange,
          }) => (
            <Styled.Item key={key}>
              <Styled.Line $color={color} $dashed={isDashed} />
              <Styled.Label>{label}</Styled.Label>

              {chanceLabel && <Styled.Price>{chanceLabel}</Styled.Price>}

              {changeLabel && (
                <TrendIndicator
                  isPositive={isPositiveChange}
                  label={changeLabel}
                />
              )}

              <Styled.Caption>{rangeLabel}</Styled.Caption>
            </Styled.Item>
          )
        )}
      </Styled.Row>
    </Styled.Root>
  );
};
